export const enum availabilityConstants {
  fetchAvailabilityRequest = 'FETCH_AVAILABILITY_REQUEST',
  fetchAvailabilitySuccess = 'FETCH_AVAILABILITY_SUCCESS',
  fetchAvailabilityFailure = 'FETCH_AVAILABILITY_FAILURE',

  updateAvailabilityRequest = 'UPDATE_AVAILABILITY_REQUEST',
  updateAvailabilitySuccess = 'UPDATE_AVAILABILITY_SUCCESS',
  updateAvailabilityFailure = 'UPDATE_AVAILABILITY_FAILURE',
  
  setLocalAvailability = 'SET_LOCAL_AVAILABILITY',
  toggleSession = 'TOGGLE_SESSION',
  setLocalReason = 'SET_LOCAL_REASON',
  resetLocalAvailability = 'RESET_LOCAL_AVAILABILITY',
}
